<script>
  export let size = 60;
  export let color = '#75ffbb';
  export let duration = '1.0s';
  export let unit = 'px';
</script>

<div class="container">
  <div class="wrapper" style="--size: {size}{unit}; --color: {color}; --duration: {duration}">
    <div class="circle" />
  </div>
</div>

<style>
  .container {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .wrapper {
    width: var(--size);
    height: var(--size);
  }
  .circle {
    width: var(--size);
    height: var(--size);
    background-color: var(--color);
    animation-duration: var(--duration);
    border-radius: 100%;
    display: inline-block;
    animation: scaleOut 1s ease-in-out infinite;
  }
  @keyframes scaleOut {
    0% {
      transform: scale(0);
    }
    100% {
      transform: scale(1);
      opacity: 0;
    }
  }
</style>
